import React from "react";

const AppBarContext = React.createContext();

export default AppBarContext;